module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(typeof _vm.document !== 'undefined') ? _c('span', [(!_vm.present) ? _c('span', [_c('i', {
    class: ['text-' + _vm.status.color, 'fa', _vm.status.icon]
  }), _vm._v(" "), _c('source-app', {
    attrs: {
      "name": _vm.document.source,
      "size": "tiny"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.document.file_url
    }
  }, [_vm._v("\n        " + _vm._s(_vm.document.file_name) + "\n      ")]), _vm._v("\n      " + _vm._s(new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(_vm.document.amount_total)) + "\n    ")], 1) : _vm._e()]) : _c('span', [_c('pulse-loader', {
    attrs: {
      "color": "#cccccc",
      "size": "8px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67189cda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Document.vue
// module id = 704
// module chunks = 1